class Controller {
  constructor(Events, City, CaptainApp, BiddingCampaigns) {
    "ngInject";

    this.Events = Events;
    this.City = City;
    this.CaptainApp = CaptainApp;
    this.BiddingCampaigns = BiddingCampaigns;

    this.updateEvent = Events.getUpdateEvent("captainApp");
    this.updateCityBidConfigurationEvent = Events.getUpdateEvent(
      "cityBidConfiguration"
    );
    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.saveAppPingFrequency = this.saveAppPingFrequency.bind(this);
    this.updateBiddingCampaignsConfig = this.updateBiddingCampaignsConfig.bind(
      this
    );
    this.updateBackupShiftConfig = this.updateBackupShiftConfig.bind(this);
  }

  $onInit() {
    this.isAppPingFrequencyDisabled = true;
    this.isBiddingCampaignsConfigDisabled = true;
    this.isBackupShiftConfigDisabled = true;
    this.appPingFrequencyRegExp = /^\d+$/;

    this.selectedCaptainAppVersion = this.selectedCaptainAppVersion || {};

    this.Events.on(this.updateEvent, this.updateAppVersion.bind(this));
    this.Events.on(
      this.updateCityBidConfigurationEvent,
      this.onUpdateBidConfiguration.bind(this)
    );

    this.getBidConfiguration();
    this.getAppVersions();
  }

  getBidConfiguration() {
    this.BiddingCampaigns.getCityConfiguration(this.cityId)
      .$promise.then((response) => {
        this.cityBidConfiguration = {
          value: response.max_bids_allowed,
          isDisabled: true,
        };
      })
      .catch((err) => this.Events.emit(this.errorEvent, err.data));
  }

  onUpdateBidConfiguration({ key, value }) {
    this.BiddingCampaigns.updateCityConfiguration(this.cityId, {
      [key]: value,
    })
      .$promise.then(() =>
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "City Maximum Bids is updated successfully.",
        })
      )
      .catch((err) => this.Events.emit(this.errorEvent, err.data));
  }

  getAppVersions() {
    this.CaptainApp.getAll({ isCityRequired: false }).$promise.then(
      (response) => {
        const format = ({ _id: id, _source: { version_name: title } }) => ({
          id,
          title,
        });
        this.appVersions = response.hits.map(format);

        const appVersion = this.appVersions.find(
          ({ id }) => id === this.selectedCaptainAppVersion.value
        );
        this.captainAppVersion = {
          ...appVersion,
          isDisabled: true,
        };
      }
    );
  }

  // App Version Details
  updateAppVersion({ id }) {
    this.City.patchAction(this.cityId, "captain_app_version", {
      captain_app_version: id,
    }).$promise.then(
      () => {
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "City Captain App version is updated successfully.",
        });
        this.captainAppVersion.isDisabled = true;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  // App Ping Frequency
  saveAppPingFrequency() {
    const {
      in_ride: inRide,
      in_backup: inBackup,
      out_ride: outRide,
    } = this.selectedPingFrequency;
    this.City.patchAction(
      this.cityId,
      "update_captain_location_ping_frequency",
      { in_ride: inRide, in_backup: inBackup, out_ride: outRide }
    ).$promise.then(
      () => {
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "City Ping Frequency is updated successfully.",
        });
        this.selectedPingFrequency.isDisabled = true;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  forceUpdateAll() {
    this.City.updateAction(
      this.cityId,
      "force_update_captain_app"
    ).$promise.then(
      () => {
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "Force update succeeded.",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  // Plan Selling
  updateBiddingCampaignsConfig() {
    this.City.patchAction(this.cityId, "bidding_campaigns_config", {
      default_location_radius: this.biddingCampaignsConfig
        .default_location_radius,
    })
      .$promise.then(() => {
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "City Plan Selling Configuration is updated successfully.",
        });
      })
      .catch((err) => this.Events.emit(this.errorEvent, err.data));
  }

  // Backup Shift
  updateBackupShiftConfig() {
    this.City.patchAction(this.cityId, "backup_shift_config ", {
      arrival_radius: this.backupShiftConfig.arrival_radius,
    })
      .$promise.then(() => {
        this.Events.emit(this.showSuccessNotificationEvent, {
          message: "Backup Shift Configuration is updated successfully.",
        });
      })
      .catch((err) => this.Events.emit(this.errorEvent, err.data));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/cityCaptainApp/cityCaptainApp.controller.js